
import { Star } from "lucide-react";

const EligibilitySection = ({ data }) => {
    const eligibilityData = data.eligibility;
    return (
        <section className="w-full bg-no-repeat bg-center bg-cover text-white"
            style={{
                backgroundImage: "url('/bg.svg')"
            }}
        >
            <div className="max-w-(--max-page-width) px-(--container-padding) py-10 md:py-16 lg:py-24 mx-auto text-center">

                <span className="bg-[#FFA2011A]/90 text-[#FFA201] text-[13px] font-normal px-3 py-2 capitalize">
                    {eligibilityData.tag}
                </span>

                <h2 className="text-[20px] md:text-[25px] lg:text-[30px] xl:text-[42px] font-bold mt-4">
                    {eligibilityData.title}
                </h2>

                <p className="text-white text-lg mt-4 w-full md:max-w-5xl lg:max-w-3xl mx-auto">
                    {eligibilityData.description}
                </p>

                <div className="grid md:grid-cols-3 gap-6 mt-6 md:mt-12">
                    {eligibilityData.items.map((item, index) => (
                        <div
                            key={index}
                            className="bg-[#0091E3] p-6 text-left flex gap-4"
                        >

                            <div className="bg-white/20 p-3 rounded-sm self-start">
                                <Star className="w-5 h-5 text-white" />
                            </div>
                            <div>
                                <h3 className="font-semibold text-lg text-white">
                                    {item.title}
                                </h3>
                                <p className="md:text-[16px] text-gray-200 mt-2 leading-relaxed">
                                    {item.text}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>

            </div>
        </section>
    );
};

export default EligibilitySection;